<template>
    <div>
        <template
            v-if="!readonly"
        >

            <rkm-row>
                <rkm-col cols="12">
                    <template>
                        <template v-if="data.model.prescricaoMedicamentos.length > 0">
                            <rkm-button
                                v-if="data.model.prescricaoMedicamentos.length === data.model.prescricaoMedicamentos.filter(m => !!m.checked).length"
                                @click="unselectAll"
                                color="primary"
                                class="print-button"
                            >
                                Desmarcar todos
                            </rkm-button>

                            <rkm-button
                                v-else
                                @click="selectAll"
                                color="primary"
                                class="print-button"
                            >
                                Selecionar todos
                            </rkm-button>
                        </template>

                        <rkm-button
                            @click="$refs.Modal.open()"
                            color="primary"
                            class="print-button"
                        >
                            Adicionar prescrição de medicamento
                        </rkm-button>

                        <rkm-button
                            v-if="data.model.prescricaoMedicamentos.filter(medicamento => !!medicamento.checked && medicamento.material && medicamento.material.receitaTipoId == enums.tipoReceita.COMUM && !medicamento.isRemoverImpressao).length > 0"
                            @click="print(enums.tipoReceita.COMUM, false)"
                            color="info"
                            class="print-button"
                        >
                            Imprimir receituário comum
                        </rkm-button>

                        <rkm-button
                            v-if="data.model.prescricaoMedicamentos.filter(medicamento => !!medicamento.checked && medicamento.material && medicamento.material.receitaTipoId == enums.tipoReceita.ESPECIAL && !medicamento.isRemoverImpressao).length > 0"
                            @click="print(enums.tipoReceita.ESPECIAL, false)"
                            color="info"
                            class="print-button"
                        >
                            Imprimir receita de controle especial
                        </rkm-button>

                        <rkm-button
                            v-if="data.model.prescricaoMedicamentos.filter(medicamento => !!medicamento.checked && medicamento.material && medicamento.material.receitaTipoId == enums.tipoReceita.ESPECIAL_AZUL && !medicamento.isRemoverImpressao).length > 0"
                            @click="print(enums.tipoReceita.ESPECIAL_AZUL, false)"
                            color="info"
                            class="print-button"
                        >
                            Imprimir receituário especial azul
                        </rkm-button>

                        <rkm-button
                            v-if="data.model.prescricaoMedicamentos.filter(medicamento => !!medicamento.checked && medicamento.material && medicamento.material.receitaTipoId == enums.tipoReceita.ESPECIAL_AMARELA && !medicamento.isRemoverImpressao).length > 0"
                            @click="print(enums.tipoReceita.ESPECIAL_AMARELA, false)"
                            color="info"
                            class="print-button"
                        >
                            Imprimir receituário especial amarela
                        </rkm-button>

                        <rkm-button
                            v-if="data.model.prescricaoMedicamentos.filter(medicamento => !!medicamento.checked && medicamento.material && medicamento.material.receitaTipoId != enums.tipoReceita.COMUM && !medicamento.isRemoverImpressao).length > 0"
                            @click="handlePreencherLaudoMedicamento()"
                            color="info"
                            class="print-button"
                        >
                            Preencher laudo de medicamentos (LME)
                        </rkm-button>

                        <rkm-button
                            v-if="data.model.prescricaoMedicamentos.filter(medicamento => !!medicamento.checked && medicamento.isManual && medicamento.receitaTipoId == enums.tipoReceita.COMUM).length > 0"
                            @click="print(enums.tipoReceita.COMUM, true)"
                            color="info"
                            class="print-button"
                        >
                            Imprimir receituário não padronizada comum
                        </rkm-button>

                        <rkm-button
                            v-if="data.model.prescricaoMedicamentos.filter(medicamento => !!medicamento.checked && medicamento.isManual && medicamento.receitaTipoId == enums.tipoReceita.ESPECIAL).length > 0"
                            @click="print(enums.tipoReceita.ESPECIAL, true)"
                            color="info"
                            class="print-button"
                        >
                            Imprimir receita não padronizada de controle especial
                        </rkm-button>
                    </template>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <List :data="data" />
                </rkm-col>
            </rkm-row>
        </template>

        <rkm-row v-else>
            <rkm-col cols="12">
                <List
                    :data="data"
                    :readonly="readonly"
                />
            </rkm-col>
        </rkm-row>

        <Modal
            :data="data"
            ref="Modal"
        />
        <ModalLaudoMedicamento
            ref="ModalLaudoMedicamento"
            @print="printLaudoMedicamentos"
            :data="Object.assign(data)"
        />

    </div>
</template>

<script>
// Components.
import List from './List'
import Modal from './Modal'
import ModalLaudoMedicamento from './components/laudo-medicamento/Modal'

// Enums.
import tipoReceita from '@/enums/cadastro/medicamento/tipoReceita'
import nacionalidade from '@/enums/cadastro/cidadao/nacionalidade'
import racaCor from '@/enums/cadastro/cidadao/racaCor'

// Vuex.
import {mapActions} from 'vuex'

// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

export default {
    components: {
        List,
        Modal,
        ModalLaudoMedicamento
    },
    created() {
        this.repositories = {
            pdf: this.getConectaSusRepository('impressao.ambulatorio'),
        }
    },
    data (){
        return{
            enums: {
                tipoReceita,
                nacionalidade,
                racaCor
            },
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        selectAll() {

            this.data.model.prescricaoMedicamentos.map(m => this.$set(m, 'checked', true))
        },
        unselectAll() {

            this.data.model.prescricaoMedicamentos.map(m => this.$set(m, 'checked', false))
        },
        handlePreencherLaudoMedicamento(){
            this.$refs.ModalLaudoMedicamento.open()
        },

        printLaudoMedicamentos(data) {

            if (!this.showRequiredFieldAtendimento()) {

                this.showAlert('Por favor, preencha todos os campos obrigatórios antes de continuar: peso, altura, CID e avaliação/conduta.', 'Atenção');

                return
            }

            if (!this.showRequiredFieldPaciente()) {

                this.showAlert(
                    'Por favor, preencha todos os campos obrigatórios do cadastro do paciente: CNS ou CPF, telefone, nome da mãe, raça/cor, número de telefone, e-mail. ' +
                    'Se o paciente for indígena, informe também a etnia.',
                    'Atenção'
                );

                return
            }

            const item = {
                emAtendimento: true,
                atendimentoId: this.data.additionals.atendimentoId,
                multiple: true,
                peso: data.peso ?? null,
                altura: data.altura ?? null,
                diagnostico: data.diagnostico,
                anamnese: data.anamnese ?? null,
                cid: this.data.avaliacaoModel.problemasCondicoes.find(item => item.cid)?.cid?.codigo || null,
                tratamentoPrevio: {
                    status: data.tratamentoPrevio.status,
                    relatar: data.tratamentoPrevio.relatar ?? null
                },

                medicamentos: this.data.model.prescricaoMedicamentos.filter(medicamento => !!medicamento.checked
                    && medicamento.material && medicamento.material.receitaTipoId != this.enums.tipoReceita.COMUM),

            };

            this.setLoading()

            this.repositories.pdf.laudoMedicamentos(this.data.additionals.paciente.id, this.camelObjectKeysToSnakeRecursive(item))
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        showRequiredFieldPaciente(){

            const { cns, cpf, nomeMae, racaCorId, telefoneNumero, nacionalidadeId, etniaIndigena} = this.data.additionals.paciente;

            if ((!cns && !cpf) || !nomeMae || !racaCorId || !telefoneNumero ||
            (racaCorId === this.enums.racaCor.INDIGENA && nacionalidadeId === this.enums.nacionalidade.BRASILEIRO && !etniaIndigena)) {

                return false;
            }

            return true;
        },
        showRequiredFieldAtendimento(){

            const { peso, altura } = this.data.objetivoModel.antropometria;

            const diagnosticoDescricao = this.data.avaliacaoModel.descricao;
            const condicoesAvaliadas = this.data.avaliacaoModel.condicoesAvaliadas;
            const doencasTransmissiveis = this.data.avaliacaoModel.doencasTransmissiveis;

            const diagnostico = diagnosticoDescricao ||
                (Array.isArray(condicoesAvaliadas) && condicoesAvaliadas.length > 0) ||
                (Array.isArray(doencasTransmissiveis) && doencasTransmissiveis.length > 0);

            const cid = this.data.avaliacaoModel.problemasCondicoes.find(item => item.cid);

            if (!peso || !altura || !diagnostico || !cid) {

                return false;
            }

            return true;
        },
        print(tipoReceita, isManual) {

            const item = {
                emAtendimento: true,
                atendimentoId: this.data.additionals.atendimentoId,
                multiple: true,
                medicamentos: isManual
                    ? this.data.model.prescricaoMedicamentos.filter(medicamento => !!medicamento.checked && medicamento.isManual && medicamento.receitaTipoId == tipoReceita)
                    : this.data.model.prescricaoMedicamentos.filter(medicamento => !!medicamento.checked && medicamento.material && medicamento.material.receitaTipoId == tipoReceita)
            };

            let request = null

            if (isManual) {
                if (tipoReceita == this.enums.tipoReceita.ESPECIAL) {
                    request = this.repositories.pdf.receitaMedicaNaoPadronizadaEspecial(this.data.additionals.paciente.id, this.camelObjectKeysToSnakeRecursive(item))
                } else {
                    request = this.repositories.pdf.receitaMedicaNaoPadronizadaComum(this.data.additionals.paciente.id, this.camelObjectKeysToSnakeRecursive(item))
                }
            } else if (tipoReceita == this.enums.tipoReceita.ESPECIAL) {
                request = this.repositories.pdf.receitaMedicaEspecial(this.data.additionals.paciente.id, this.camelObjectKeysToSnakeRecursive(item))
            } else if (tipoReceita == this.enums.tipoReceita.ESPECIAL_AMARELA) {
                request = this.repositories.pdf.receitaMedicaEspecialAmarela(this.data.additionals.paciente.id, this.camelObjectKeysToSnakeRecursive(item))
            } else if (tipoReceita == this.enums.tipoReceita.ESPECIAL_AZUL) {
                request = this.repositories.pdf.receitaMedicaEspecialAzul(this.data.additionals.paciente.id, this.camelObjectKeysToSnakeRecursive(item))
            } else {
                request = this.repositories.pdf.receitaMedicaComum(this.data.additionals.paciente.id, this.camelObjectKeysToSnakeRecursive(item))
            }

            this.setLoading()

            request
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, file, repository, stringCase],
    props: {
        data: {type: Object, required: true},
        readonly: {type: Boolean, default: false},
    },
}
</script>

<style scoped>
.print-button {
    margin-left: 0px!important;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
}
</style>